import { Button, Container } from '@doist/marketist';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useTranslation } from 'next-i18next';
import css from './contact-us-section.module.css';
function ContactUsSection() {
  const {
    t
  } = useTranslation('helpcenter');
  return <Container className={css.container} data-sentry-element="Container" data-sentry-component="ContactUsSection" data-sentry-source-file="contact-us-section.tsx">
            <SectionHeader title={t('contactUsSection.title')} subtitle={t('contactUsSection.subtitle')} button={<Button href="/contact">{t('contactUsSection.contactUs')}</Button>} data-sentry-element="SectionHeader" data-sentry-source-file="contact-us-section.tsx" />
        </Container>;
}
export { ContactUsSection };